export enum RecaptchaErrorMessages {
  TOAST = 'Falha na verificação. Marque a caixa de seleção e tente novamente',
  FIELD = 'Confirme que você não é um robô.',
}
